import type { ReactNode } from "react";

import { Stack } from "@mui/material";
import { IconButton } from "components/IconButton";

type DynamicRecordDrawerHeaderProps = {
  actions?: ReactNode;
  onClose: () => void;
  subtitle?: string;
  title: string;
};

export const DynamicRecordDrawerHeader = ({ actions, onClose, subtitle, title }: DynamicRecordDrawerHeaderProps) => {
  return (
    <Stack className="w-full min-w-0 flex-row items-start justify-between gap-3">
      <Stack className="min-w-0 flex-1 flex-col items-start gap-1">
        <h2 className="text-lds-foreground-heading font-ds-headline-md">{title}</h2>
        {subtitle && <p className="font-ds-body-regular-sm text-lds-foreground-muted">{subtitle}</p>}
      </Stack>
      <Stack className="mt-px shrink-0 flex-row items-center gap-2">
        {actions}
        <IconButton
          buttonProps={{ className: "shrink-0", onClick: onClose, variant: "tertiary" }}
          iconProps={{ iconName: "Close" }}
        />
      </Stack>
    </Stack>
  );
};
